import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { AppConstants } from '../../../environments/constants';
import { NavigationEnd, Router } from '@angular/router';
import { RolePermissions } from '../../model/rolePermissions';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { SidebarActiveLinkService } from 'src/app/services/sidebar-active-link.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Input() permissions: RolePermissions;
  @Output() changeThemeEvent = new EventEmitter<string>();

  rottaOrdini = AppConstants.ORDINI_ROUTE;
  rottaArchivi = AppConstants.ARCHIVI_ROUTE;
  rottaDocumenti = AppConstants.DOCUMENTS_ROUTE;
  rottaCestino = AppConstants.CESTINO_ROUTE;
  rottaSvincoli = AppConstants.SVINCOLI_ROUTE;
  rottaNotifiche = AppConstants.NOTIFICHE_ROUTE;
  rottaAdmin = AppConstants.ADMIN_PAGE;
  rottaIspezioni = AppConstants.ISPEZIONI_ROUTE;
  rottaNonConformita = AppConstants.NONCONFORMITA_ROUTE;

  myNavConfig;
  myActiveLink = '/';
  myNavAriaLabel = 'Sidebar';
  switchThemeSide = 'left';

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly sidebarActiveLinkService: SidebarActiveLinkService
  ) {}

  ngOnInit() {
    const theme = sessionStorage.getItem('theme');
    if (theme === 'dark') {
      document.querySelector('html').classList.add('snam_dark_new-theme');
      this.switchThemeSide = 'left';
    } else {
      document.querySelector('html').classList.remove('snam_dark_new-theme');
      this.switchThemeSide = 'right';
    }
    this.changeThemeEvent.emit(theme);
    this.translate.get('sidenav').subscribe(res => {
      this.buildNavConfig(res);
    });
    this.translate.onLangChange.subscribe(lang => {
      this.translate.get('sidenav').subscribe(res => {
        this.buildNavConfig(res);
      });
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlPath = event.urlAfterRedirects.split('/');
        this.myActiveLink =
          event.urlAfterRedirects && event.urlAfterRedirects !== '/dashboard'
            ? urlPath[1]
            : '/';
      });

    this.sidebarActiveLinkService.activeLink$.subscribe(link => {
      if (link) {
        this.myActiveLink = link;
      }
    });
  }

  buildNavConfig(res: any) {
    if (!this.permissions) {
      this.myNavConfig = { categories: [] };
      this.myNavConfig = { categories: [] };
      return;
    }
    this.myNavConfig = {
      categories: [
        this.permissions.canViewAdminBtn
          ? {
              firstLevelName: 'Home',
              firstLevelIcon: 'icon-home',
              hasChildren: false,
              url: this.rottaAdmin,
              ariaLabel: 'Home',
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewHomeBtn
          ? {
              firstLevelName: 'Home',
              firstLevelIcon: 'icon-home',
              hasChildren: false,
              url: '/',
              ariaLabel: 'Home',
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewNotificationsBtn
          ? {
              firstLevelName: res['Notifiche'],
              firstLevelIcon: 'icon-notification',
              hasChildren: false,
              url: this.rottaNotifiche,
              ariaLabel: res['Notifiche'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewOrdersBtn
          ? {
              firstLevelName: res['Ordini'],
              firstLevelIcon: 'icon-list',
              hasChildren: false,
              url: this.rottaOrdini,
              ariaLabel: res['Ordini'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewInspectionsBtn
          ? {
              firstLevelName: res['Ispezioni'],
              firstLevelIcon: 'icon-maintenance',
              hasChildren: false,
              url: this.rottaIspezioni,
              ariaLabel: res['Ispezioni'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewReleasesBtn
          ? {
              firstLevelName: res['Svincoli'],
              firstLevelIcon: 'icon-checklist-notes',
              hasChildren: false,
              url: this.rottaSvincoli,
              ariaLabel: res['Svincoli'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewNonCompliancesBtn
          ? {
              firstLevelName: res['NonConformita'],
              firstLevelIcon: 'icon-prohibition',
              hasChildren: false,
              url: this.rottaNonConformita,
              ariaLabel: res['NonConformita'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewDocumentsBtn
          ? {
              firstLevelName: res['Documenti'],
              firstLevelIcon: 'icon-document',
              hasChildren: false,
              url: this.rottaDocumenti,
              ariaLabel: res['Documenti'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewArchiviBtn
          ? {
              firstLevelName: res['Archivi'],
              firstLevelIcon: 'icon-archive',
              hasChildren: false,
              url: this.rottaArchivi,
              ariaLabel: res['Archivi'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
        this.permissions.canViewTrashBtn
          ? {
              firstLevelName: res['Cestino'],
              firstLevelIcon: 'icon-delete-1',
              hasChildren: false,
              url: this.rottaCestino,
              ariaLabel: res['Cestino'],
              isExternal: false,
              isRouterLink: true,
            }
          : null,
      ].filter(Boolean),
    };
  }

  onSidebarClickLink(event: CustomEvent) {
    const url = event.detail.url;
    this.breadcrumbService.setFromBreadcrumb(false);
    this.breadcrumbService.resetBreadcrumbFilter();
    this.myActiveLink = url;
    if (url === this.rottaIspezioni) {
      this.router.navigate([this.rottaIspezioni], {
        state: { currentDate: new Date() },
      });
      return;
    }
    if (url === this.rottaCestino || url === this.rottaDocumenti) {
      const target = url === this.rottaCestino ? 'cestino' : 'documenti';
      this.router.navigateByUrl('/' + this.rottaDocumenti).then(() => {
        this.sidebarActiveLinkService.setActiveLink(target);
      });
      return;
    }
    this.router.navigateByUrl(url);
  }

  onSwitchChange(e: CustomEvent) {
    let theme: string;
    if (e.detail.id === 'switchLeftThemeId') {
      theme = 'dark';
      document.querySelector('html').classList.add('snam_dark_new-theme');
    } else if (e.detail.id === 'switchRightThemeId') {
      theme = 'light';
      document.querySelector('html').classList.remove('snam_dark_new-theme');
    }
    sessionStorage.setItem('theme', theme);
    this.changeThemeEvent.emit(theme);
  }
}
